import React from "react";
import '../App.css'; // Make sure this file exists and contains your styles
import Form from './Form';

function Content() {
  
  return (
    <div className="p-4" >
            <Form />
    </div>
  );
}

export default Content;
